export default __webpack_public_path__ + "media/images/open_tab_white-79071b023ce2994117bdd3a8b0bd202b.png";